import { ATextMeasure } from "./AtextMeasure";

export const TextMeasureContribution = Symbol.for("TextMeasureContribution");

export class DefaultTextMeasureContribution extends ATextMeasure {
    constructor() {
        super(...arguments), this.id = "DefaultTextMeasureContribution";
    }
}
//# sourceMappingURL=textMeasure-contribution.js.map
